<script>
import {Bar} from "vue-chartjs";
import 'chartjs-plugin-labels';

export default {
  name: "BarChart",
  extends: Bar,
  props: {
    label: {
      type: String,
    },
    chartData: {
      type: Array
    },
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
          position: 'right',
          align: 'center',
        },
        scales: {
          yAxes: [{
            ticks: {
              min: 0,
              max: 110,
              callback: function (value) {
                if (value <= 100) return value + "%"
              }
            },
            scaleLabel: {
              display: true,
            }
          }]
        },
        plugins: {
          labels:
              {
                render: 'value',
                fontColor: '#fff',
                fontSize: 18,
                fontStyle: 'bold',
                shadowColor: 'black',
                showZero: true,
                textShadow: true,
              },
        },
      }
    }
  },
  mounted() {
    const dates = this.chartData.map(d => d.letter)
    let totals = this.chartData.map(d => d.total)
    let total = 0;
    totals.forEach(function (num) {
      total += num ? num : 0;
    });
    totals = totals.map(a => Math.round((a * 100) / total))
    this.renderChart({
      labels: dates,
      datasets: [
        {
          backgroundColor: ['#fe0100', '#fdae34', '#FEDD02', '#C2D82A', '#15A3E4', '#8B7964'],
          label: this.label,
          data: totals
        }
      ]
    }, this.options)
  },
}
</script>

<style scoped>
</style>
